import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { preCadastroAdmissaoService } from '../../services/preCadastroAdmissaoService';
import { SI_SOLICITACOES_QUERY_KEYS } from './useSolicitacoesQuery';

export const SI_PRE_CADASTRO_QUERY_KEYS = {
  byId: (id: string) => ['si', 'pre-cadastro-admissao', id] as const,
  pendentes: ['si', 'pre-cadastro-admissao', 'pendentes'] as const,
};

export function usePreCadastroAdmissaoQuery(id: string | null | undefined) {
  return useQuery({
    queryKey: SI_PRE_CADASTRO_QUERY_KEYS.byId(id ?? ''),
    queryFn: () => preCadastroAdmissaoService.getById(id as string),
    enabled: Boolean(id),
  });
}

/** Pendentes pro vínculo manual — só busca com o modal aberto. */
export function usePreCadastrosPendentesQuery(enabled: boolean) {
  return useQuery({
    queryKey: SI_PRE_CADASTRO_QUERY_KEYS.pendentes,
    queryFn: () => preCadastroAdmissaoService.listarPendentes(),
    enabled,
  });
}

export function useVincularPreCadastroManual(solicitacaoId: string) {
  const queryClient = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (preCadastroId: string) => preCadastroAdmissaoService.vincularManual(solicitacaoId, preCadastroId),
    onSuccess: ({ aplicadoAoColaborador }) => {
      toast.success(
        aplicadoAoColaborador ? 'Pré-cadastro vinculado e aplicado ao perfil do colaborador.' : 'Pré-cadastro vinculado.'
      );
      queryClient.invalidateQueries({ queryKey: SI_SOLICITACOES_QUERY_KEYS.detalhe(solicitacaoId) });
      queryClient.invalidateQueries({ queryKey: SI_PRE_CADASTRO_QUERY_KEYS.pendentes });
    },
    onError: (error: Error) => toast.error(error.message || 'Não foi possível vincular o pré-cadastro.'),
  });
}
